/**
 * tasksense-scheduler-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which day-of-month rule a monthly schedule uses to pick its fire date.
 */
export const MonthlyCalculationMode = {
    OnSelectedDay: 'ON_SELECTED_DAY',
    OnFirstDayOfMonth: 'ON_FIRST_DAY_OF_MONTH',
    OnLastDayOfMonth: 'ON_LAST_DAY_OF_MONTH',
    OnFirstBusinessDayOfMonth: 'ON_FIRST_BUSINESS_DAY_OF_MONTH',
    OnLastBusinessDayOfMonth: 'ON_LAST_BUSINESS_DAY_OF_MONTH',
    OnFirstSelectedWeekdayOfMonth: 'ON_FIRST_SELECTED_WEEKDAY_OF_MONTH',
    OnSecondSelectedWeekdayOfMonth: 'ON_SECOND_SELECTED_WEEKDAY_OF_MONTH',
    OnThirdSelectedWeekdayOfMonth: 'ON_THIRD_SELECTED_WEEKDAY_OF_MONTH',
    OnFourthSelectedWeekdayOfMonth: 'ON_FOURTH_SELECTED_WEEKDAY_OF_MONTH',
    OnLastSelectedWeekdayOfMonth: 'ON_LAST_SELECTED_WEEKDAY_OF_MONTH'
} as const;
export type MonthlyCalculationMode = typeof MonthlyCalculationMode[keyof typeof MonthlyCalculationMode];

